import identifyQualifiedTraffic from "@utils/identifyQualifiedTraffic";
import { handleCustomUDL } from "@utils/UDLUtils";

interface OptionalProps {
  category?: string;
  fileType?: string;
  fileName?: string;
  courseId?: string;
  locationName?: string;
  locationId?: string;
}

const prependUrlDomain = (url: string) =>
  url.includes("http") ? url : `${window.location.origin}${url}`;

export const handleUDL = (
  eventName: string,
  text: string,
  url: string,
  optionalProps: OptionalProps = {},
  domainUrl = true,
) => {
  if (!eventName || !text) return;

  const { category, fileType, fileName, courseId, locationName, locationId } =
    optionalProps;
  const resolvedUrl = url && domainUrl ? prependUrlDomain(url) : url;
  const eventProperties = {
    link_text: text,
    ...(url && { link_url: resolvedUrl }),
    ...(url && { ...identifyQualifiedTraffic(resolvedUrl) }),
    ...(category && { category }),
    ...(courseId && { course_id: courseId }),
    ...(fileType && { file_type: fileType }),
    ...(fileName && { file_name: fileName }),
    ...(locationName && { location_name: locationName }),
    ...(locationId && { location_id: locationId }),
  };

  handleCustomUDL(eventName, eventProperties);
};

export const locationFinderSearchTypeToType = {
  laboratory: "lab_finder",
  dentist: "dentists",
  worldwidelocation: "worldwide_location",
};

export const handleLocationFinderUDL = (
  eventName: string,
  searchType: string,
  properties = {},
) => {
  const dataLayerObj = {
    event: "genericEvent",
    event_name: eventName,
    ...properties,
  };
  dataLayerObj["location_finder_type"] =
    locationFinderSearchTypeToType[searchType];

  window.dataLayer.push(dataLayerObj);
};

export const getUdlEventName = (
  eventNamePrefix: string,
  eventNameType: string,
) => `${eventNamePrefix}_${eventNameType}_click`;
